import { useEffect, useState } from "react";
import { useGameClubContext } from "../Hook/GameClubContext";
import { ClubTab } from "../Hook/useGameClub";
import { GameClubWrapper } from "../Style/GameStyles";
import { GameClubAll } from "./GameClubAll";
import { GameClubJoin } from "./GameClubJoin";
import { GameClubMy } from "./GameClubMy";
import { GameClubTab } from "./GameClubTab";
import { GameClubMember } from "./GameClubUser";
import { GameClubHeader } from "./GameClubHeader";
import { GameClubChat } from "./GameClubChat";
import { getClubUserState } from "../../../../api/game-club";
import { LOCAL_STORAGE_ACCESS_KEY } from "../../../../utils/network";
import { useRecoilValue } from "recoil";
import { insetState } from "../../../../recoil/inset";

export const GameClub = () => {
  const {
    isGameClubTab,
    isClubJoin,
    setIsClubJoin,
    popupType,
    getData,
    setMyClub,
    setMyJoinRequest,
    resetUserData,
    setGameClubTab,
  } = useGameClubContext();
  const inset = useRecoilValue(insetState);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const getUserData = async () => {
    const token = localStorage.getItem(LOCAL_STORAGE_ACCESS_KEY);
    const accessToken = token ? token.replace("Bearer ", "") : "-";

    const res = await getClubUserState(accessToken);
    if (res.result === 1) {
      if ("club" in res.payload) {
        setMyJoinRequest({
          ...res.payload.club,
          requestId: res.payload.requestId,
        });
      } else {
        setMyClub(res.payload);
      }
    }
  };

  const moveToPage = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const page = urlParams.get("page");
    if (page === "club-chat") {
      setTimeout(() => {
        setGameClubTab(ClubTab.CHAT);
      }, 500);
      // 파라미터 사용 후 URL에서 제거
      const newUrl = window.location.pathname;
      window.history.replaceState({}, "", newUrl);
    }
  };

  useEffect(() => {
    getUserData();
    moveToPage();
  }, [resetUserData]);

  return (
    <GameClubWrapper isApp={inset}>
      {isClubJoin && (
        <GameClubJoin
          onClose={async () => {
            setIsClubJoin(false);
            if (getData) {
              await getData();
            }
          }}
          type={popupType}
        />
      )}
      {(isGameClubTab(ClubTab.ALL) || isGameClubTab(ClubTab.MY)) && (
        <GameClubTab />
      )}
      {(isGameClubTab(ClubTab.MEMBER) || isGameClubTab(ClubTab.CHAT)) && (
        <GameClubHeader
          isCalendarOpen={isCalendarOpen}
          setIsCalendarOpen={setIsCalendarOpen}
        />
      )}
      {isGameClubTab(ClubTab.ALL) && <GameClubAll></GameClubAll>}
      {isGameClubTab(ClubTab.MY) && <GameClubMy></GameClubMy>}
      {isGameClubTab(ClubTab.MEMBER) && (
        <GameClubMember
          isCalendarOpen={isCalendarOpen}
          setIsCalendarOpen={setIsCalendarOpen}
        />
      )}
      {isGameClubTab(ClubTab.CHAT) && <GameClubChat />}
    </GameClubWrapper>
  );
};
